$(document).ready(function() {
  var $width = $('.left .cell.city').width();
  var $coordination =  $width / 2 + 10;
  $('.banner .triangle').css('left', $coordination);
});
